import { FieldAccessor } from "@contember/binding";
const getDiscriminatedDatum = (data, discriminant) => {
  const discriminantValue = discriminant instanceof FieldAccessor ? discriminant.value : discriminant;
  return data.get(discriminantValue);
};
export {
  getDiscriminatedDatum
};
//# sourceMappingURL=getDiscriminatedDatum.js.map
